import { useMemo } from 'react';
import { useCurrentFrame, useVideoConfig } from 'remotion';

/**
 * 현재 Remotion 프레임에 대응하는 WebP 애니메이션 프레임 인덱스를 계산한다.
 * @remotion/gif의 useCurrentGifIndex와 동일한 로직.
 */
export function useCurrentWebpIndex({
  delays,
  playbackRate,
}: {
  delays: number[];
  playbackRate: number;
}): number {
  const currentFrame = useCurrentFrame();
  const videoConfig = useVideoConfig();

  const duration = useMemo(() => {
    if (delays.length !== 0) {
      return delays.reduce((sum, delay) => sum + (delay ?? 0), 0);
    }
    return 1;
  }, [delays]);

  if (delays.length === 0) {
    return 0;
  }

  const updatedFrame = currentFrame / (1 / playbackRate);
  const time = (updatedFrame / videoConfig.fps) * 1000;

  // 항상 루프
  let currentTime = time % duration;
  for (let i = 0; i < delays.length; i++) {
    const delay = delays[i]!;
    if (currentTime < delay) {
      return i;
    }
    currentTime -= delay;
  }

  return 0;
}
